import { render, staticRenderFns } from "./SuperkidVolunteer.vue?vue&type=template&id=345ccf6e&scoped=true&"
import script from "./SuperkidVolunteer.vue?vue&type=script&lang=js&"
export * from "./SuperkidVolunteer.vue?vue&type=script&lang=js&"
import style0 from "./SuperkidVolunteer.vue?vue&type=style&index=0&id=345ccf6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345ccf6e",
  null
  
)

export default component.exports